/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="IpRestrictions.module.ts" />

module Meevo.Plugins.IpRestrictions {
    class IpRestrictionsController extends Meevo.Components.BaseClasses.DataMaintenanceControllerBase {
        public displayNameColumn = { header: "Location Name", fieldName: 'StoreName', sortDirection: Model.SortDirection.Ascending, width: 35 };
        public coColumnsSet = [
            { header: "IP Restricted", fieldName: 'OwnedByLocationName', sortDirection: null, width: 33 },
            { header: "Offsite Access", fieldName: 'OwnedByLocationName', sortDirection: null, width: 33 },
            { header: "User Overrides", fieldName: 'OwnedByLocationName', sortDirection: null, width: 33 }

        ];

        static $inject = [
            "meevo.AppSettings",
            "meevo.components.common.DataService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            "meevo.components.logging.LoggingService",
            "meevo.components.common.SecurityService",
            "meevo.components.tracking.TrackingService",
            "$rootScope",
            "$scope",
            "$state",
            "meevo.ContextParams",
            'meevo.components.short-cuts.ShortCutsService',

            "meevo.components.busy.BusyService",
            "$http"];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: any,
            protected contextParams: Meevo.IContextParams,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,

            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $http: angular.IHttpService) {
           
            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);
            
            if (!this.identityService.inCentralOfficeMode()) {

                this.visualState = Model.MaintenanceFormVisualState.Detail;
                this.selectedItemId = <any>this.identityService.current().locationId;                
            }
        }

        async applyParams() {
            var params = {};
            if (!this.identityService.inCentralOfficeMode()) {
                 params = {
                    targetState: Model.MaintenanceFormVisualState.Detail,
                    id: this.identityService.current().locationId,
                    selectedItemId: this.identityService.current().locationId,
                    actionState: Model.MaintenanceFormState.Editing
                }
                
            }
            await super.applyParams(params);
        }

        /**
        * Creates the context for editing/adding an item.
        * @return {}
        */
        createContext(): void {
            this.busyService.start();
            this.securityService.checkSection(this.meevoSecurityKeys.MANAGEMENT_IPRESTRICTION).then(() => {
                this.busyService.stop();

                this.context = new IpRestrictionsContext(this.appSettings, this.dataService, this.modalService, this.identityService, this.loggingService, this.trackingService, this.securityService, this.$http, this.busyService);
                super.createContext();
                this.selectedItemId = this.selectedItemId != null ? this.selectedItemId : <any>this.identityService.current().locationId;
                this.context.activate(this.selectedItemId, null, this.asLocationId);
                this.context.deactivate = () => {
                    this.visualState = Model.MaintenanceFormVisualState.Detail;
                }


            }).catch(() => {
                this.busyService.stop();
            });
        }
    }

    angular.module("meevo.plugins.ipRestrictions")
        .controller("meevo.plugins.ipRestrictions.IpRestrictionsController", IpRestrictionsController);
}